import React from 'react';
import PropTypes from 'prop-types';
import { Toolbar, Paper } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { themeTypeToBool } from '../../utils/helpers';

const useStyles = theme => ({
    appBar: {
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        background: theme.palette.paper,
        padding: theme.spacing(1),
        width: "100%",
    },
    toolbarContainer: {
        width: "100%",
        transition: theme.transitions.create('all', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
        display: "flex",
        alignItems: "center",
        justifyContent: 'space-between'
    },
    button: {
        margin: theme.spacing(0.5),
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1)
    },
    buttonLabel: {
        color: "#FFF"
    },
    buttonDefault: {
        background: themeTypeToBool(theme.palette.type) ? "#43425D" : theme.palette.secondary[200]
    }
});

const TopBar = (props) => {
    const { classes } = props;

    return (
        <Paper
            square
            color='default'
            position="static"
            className={classes.appBar}>
            <Toolbar style={{ padding: 0 }}>
                <div className={classes.toolbarContainer}>
                    {props.children}
                </div>
            </Toolbar>
        </Paper>
    );
};

export default  withStyles(useStyles)(TopBar);

TopBar.propTypes = {
    classes: PropTypes.object,
    children: PropTypes.node
};